import { render, staticRenderFns } from "./UnitPurchaseRegistration.vue?vue&type=template&id=73afc564&scoped=true&"
import script from "./UnitPurchaseRegistration.vue?vue&type=script&lang=js&"
export * from "./UnitPurchaseRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73afc564",
  null
  
)

export default component.exports